import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import Swal from "sweetalert2";
import { Color } from "../../../../../utils/theme";
import { cleannerError } from "../../../../../utils/utils";
import { BannerData } from "../../../../../utils/api/config/config.type";
import {
	useGetBannerQuery,
	useUpdateBannerMutation,
} from "../../../../../utils/api/config/config.api";
import { QueryError } from "../../../../../utils/type";

function useBanner() {
	const validationSchema = yup.object().shape({
		home: yup.object({
			description: yup.string().required().label("Description"),
			jours: yup.string().required().label("Date"),
			// heures: yup.string().required().label("Heure"),
		}),
	});

	const {
		register,
		handleSubmit,
		formState: { errors },
		setValue,
		clearErrors,
	} = useForm<BannerData>({
		resolver: yupResolver(validationSchema),
	});

	const { data, } = useGetBannerQuery();
	// console.log({ data });
	const [updateBanner, { isLoading, isSuccess, error, isError }] = useUpdateBannerMutation();

	useEffect(() => {
		if (data?.home) {
			setValue("home.description", data?.home?.description);
			setValue("home.jours", data?.home?.jours);
			// setValue("home.heures", data?.home?.heures);
		}
	}, [data]);

	useEffect(() => {
		if (isSuccess) {
			Swal.fire({
				icon: "success",
				title: `Modifié avec succès`,
				iconColor: Color.success,
				showConfirmButton: false,
				timer: 2000,
			});
		}
		const err = error as QueryError;
		if (isError) {
			Swal.fire({
				icon: "error",
				title: err?.data?.message ? err?.data?.message : "Une erreur a survenu",
				showConfirmButton: false,
				timer: 5000,
			});
		}
	}, [isLoading]);

	useEffect(() => {
		cleannerError(errors, clearErrors);
	}, [errors]);

	const onSubmit = (data: BannerData) => {
		console.log(JSON.stringify(data));
		updateBanner(data);
	};

	return {
		register,
		errors: errors,
		onSubmit: handleSubmit(onSubmit),
		setValue,
		isLoading: isLoading,
	};
}
export default useBanner;
